import { useCallback } from 'react';
import { useLowLevelAuthFlowMachine } from '../LowLevelAuthFlowMachineContext';
import { LowLevelCustomAuthError } from '../LowLevelAuthFlowMachineDefinition';

export function useAuthFlowActions<
  AuthRequest,
  AuthResponse,
  AuthError extends LowLevelCustomAuthError = never,
>() {
  const { send } = useLowLevelAuthFlowMachine<
    AuthRequest,
    AuthResponse,
    AuthError
  >();

  const handleParamChange = useCallback(
    (name: string, value: string | Array<string>) => {
      send({ type: 'UPDATE_PARAM', name, value });
    },
    [send]
  );

  return { handleParamChange };
}
